module.exports = window.ReactDOM